/* src/app/modules/institutions/institutions-clienttemplates/institutions-clienttemplates.component.scss */
:host button {
  margin-right: 10px;
  margin-top: 20px;
}
:host button:last-of-type {
  margin-right: 0;
}
:host .cw-button-wrapper {
  justify-content: flex-start;
}
/*# sourceMappingURL=institutions-clienttemplates.component.css.map */
